import { httpRequest } from "@services/http";

export class CommandAddUserToOrg {
  async run(profileId: number, orgId: number): Promise<void> {
      const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/profiles/${profileId}/organizations/${orgId}`;
      try {
      await httpRequest(url, { method: "POST" });
    } catch (error) {
      console.error("Error adding user to org:", error);
      throw error;
    }
  }
}
